export interface CollectionRevisionTargetRouteIdentity {
  readonly collectionId: string;
  readonly revisionId: string;
  readonly targetId: string;
}

type CollectionRevisionRouteParams = Readonly<
  Record<string, string | null | undefined>
>;

export function buildCollectionRevisionTargetRoute(
  identity: CollectionRevisionTargetRouteIdentity,
): readonly string[] {
  return [
    'collection',
    requireRouteId(identity.collectionId, 'collectionId'),
    'revisions',
    requireRouteId(identity.revisionId, 'revisionId'),
    'targets',
    requireRouteId(identity.targetId, 'targetId'),
  ];
}

export function parseCollectionRevisionTargetRoute(
  params: CollectionRevisionRouteParams,
): CollectionRevisionTargetRouteIdentity | null {
  const collectionId = optionalRouteId(params['collectionId']);
  const revisionId = optionalRouteId(params['revisionId']);
  const targetId = optionalRouteId(params['targetId']);
  if (!collectionId || !revisionId || !targetId) return null;
  return Object.freeze({ collectionId, revisionId, targetId });
}

function requireRouteId(value: string, field: string): string {
  const normalized = optionalRouteId(value);
  if (!normalized) throw new TypeError(`${field} must be a non-empty string`);
  return normalized;
}

function optionalRouteId(value: unknown): string | null {
  return typeof value === 'string' && value.trim().length > 0
    ? value.trim()
    : null;
}
